var map = {
	"./Carne.png": 9172,
	"./Cereali, frutta secca, varie.png": 1744,
	"./Condimenti e contorni.png": 1156,
	"./Farine.png": 9142,
	"./Formaggi.png": 4347,
	"./Ittico.png": 4593,
	"./Legumi.png": 122,
	"./Pasta.png": 6372,
	"./Prodotti colazione e forno.png": 5135,
	"./Riso.png": 3440,
	"./Salumi.png": 6314,
	"./Spezie.png": 6627,
	"./Uova.png": 6078,
	"./Verdura e frutta.png": 4227,
	"./Vino.png": 771,
	"./default.png": 8818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 986;